import styled from 'styled-components';

const NewsQuote = styled.p`
    user-select: none;
    font-family: Caveat, serif;
    font-size: 18px;
    color: black;
    margin: 25px;
    margin-top: 60px;
    white-space: pre-wrap;
`;

export default NewsQuote;
